var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert } from '@otp/icons';
import { useTranslation } from 'react-i18next';
import { Button } from '../button';
import { Modal } from '../modal';
import styles from './form-dirty-modal.module.css';
import clsx from 'clsx';
export const FormDirtyModal = (_a) => {
    var { onClose, onCloseWithoutSaving } = _a, props = __rest(_a, ["onClose", "onCloseWithoutSaving"]);
    const { t } = useTranslation();
    const title = props.title || t('form-dirty-modal.title', 'Warning');
    const message = props.message ||
        t('form-dirty-modal.message', 'You are about to exit without saving, any edits made will be lost. Would you like to proceed?');
    const cancelButtonMessage = props.cancelButtonMessage ||
        t('form-dirty-modal.cancel-button-text', 'Cancel');
    const yesButtonMessage = props.yesButtonMessage ||
        t('form-dirty-modal.yes-button-text', 'Yes, Close without saving');
    const titleElement = (_jsxs("div", { className: clsx(styles.title), children: [_jsx(Alert, {}), title] }));
    const buttonElements = [
        _jsx(Button, { variant: "contained", color: "error", onClick: onCloseWithoutSaving, "aria-label": yesButtonMessage, children: yesButtonMessage }),
        _jsx(Button, { variant: "outlined", color: "error", onClick: onClose, "aria-label": cancelButtonMessage, children: cancelButtonMessage }),
    ];
    return (_jsx(Modal, { maxWidth: "xs", fullWidth: true, open: props.open, onClose: onClose, title: titleElement, actions: buttonElements, children: message }));
};
